const trade = {
  label: 'Trade',
  levels: [
    {
      name: 'Greenhorn',
      minExperience: 0,
      action: 'Buy',
      description: 'with little sense of the worth, pays dearly for common goods',
      bonus: 0.0
    },
    {
      name: 'Wary Bargainer',
      minExperience: 10,
      action: 'Haggle',
      description: 'grows cautious, begins to question the cost of necessities',
      bonus: 0.05
    },
    {
      name: 'Sharp Dealer',
      minExperience: 25,
      action: 'Barter',
      description: 'eyes sharper, strikes deals with a newfound prudence',
      bonus: 0.1
    },
    {
      name: 'Town Merchant',
      minExperience: 45,
      action: 'Trade',
      description: 'earns a stand, trades goods with the passersby and locals alike',
      bonus: 0.15
    },
    {
      name: 'Territory Trader',
      minExperience: 70,
      action: 'Expand',
      description: 'ventures beyond, carrying wares between towns sparse and remote',
      bonus: 0.2
    },
    {
      name: 'Circuit Trader',
      minExperience: 100,
      action: 'Diversify',
      description: 'known on the circuit, trades in goods rare and sundry',
      bonus: 0.3
    },
    {
      name: 'Supply Scout',
      minExperience: 135,
      action: 'Forecast',
      description: 'reads the land and its wants, brings what’s needed before the asking',
      bonus: 0.45
    },
    {
      name: 'Trade Envoy',
      minExperience: 175,
      action: 'Supply',
      description: 'binds towns in trade, a lifeline in the wilderness',
      bonus: 0.6
    },
    {
      name: 'Caravan Master',
      minExperience: 220,
      action: 'Direct',
      description: 'leads caravans laden, the veins of commerce pulsing through dust',
      bonus: 0.8
    },
    {
      name: 'Frontier Magnate',
      minExperience: 270,
      action: 'Monopolize',
      description: 'at the helm of trade, forges empires in the expanse of the wild',
      bonus: 1.0
    }
  ],
  traitMultipliers: {
    haggling: 0.05
    // Luck: 0.02,
  }
};

export default trade;
